<template>
	<div id="settings">
		<div class="row">
			<div class="col-12">
				<div class="card col-12">
					<el-form ref="teamsForm" label-position="top" :model="settings" label-width="120px" @submit.native.prevent >
						<el-tabs v-model="activeTab">
							<el-tab-pane label="Display" name="display">
								<input name="SettingsID" id="SettingsID" type="hidden" v-model="settings.SettingsID" >
								<div class="row form-group col-12">
									<label class="mb-1 control-label" for="CustomerID">Customer:</label>
									<input name="CustomerID" id="CustomerID" class="form-control disabled" :disabled="true" type="text" v-model="settings.CustomerID" >
								</div>
								<div class="row form-group col-12">
									<label class="mb-1 control-label" for="SiteName">Site Name:</label>
									<input name="SiteName" id="SiteName" class="form-control" type="text"  v-model="settings.Params.SiteName">
								</div>
								<div class="row form-group col-12">
									<label class="mb-1 control-label" for="MainURL">Main Site URL:</label>
									<input name="MainURL" id="MainURL" class="form-control" type="text"  v-model="settings.Params.MainURL">
								</div>
								<div class="row form-group col-12">
									<label class="mb-1 control-label" for="mainLogo">Main Logo:</label>
									<form class="form-horizontal fade-in-effect" novalidate method="post" enctype="multipart/form-data">
										<div class="fileinput-button " style="text-align:center;">
											<div id="mainLogo" v-bind:class="{ 'success_upload' : isSuccess, 'failed_upload' : isFailed }" class="logo" style="position:relative;" :style="mainLogo">
												<div style="position:absolute;top:24px;left:24px;" v-if="isSaving"><i class="fas fa-spinner fa-spin fa-2x"></i> </div>
												<input type="file" id="MainLogoInput" name="MainLogo" :disabled="isSaving" @change="uploadLogo($event.target.name)" accept="image/*" class="input-file">
											</div>
										</div>
									</form>
								</div>
								<div class="row form-group col-12">
									<label class="mb-1 control-label" for="smallLogo">Small Logo:</label>
									<form class="form-horizontal fade-in-effect" novalidate method="post" enctype="multipart/form-data">
										<div class="fileinput-button " style="text-align:center;">
											<div id="smallLogo" v-bind:class="{ 'success_upload' : isSuccess, 'failed_upload' : isFailed }" class="logo" style="position:relative;" :style="smallLogo">
												<div style="position:absolute;top:24px;left:24px;" v-if="isSaving"><i class="fas fa-spinner fa-spin fa-2x"></i> </div>
												<input type="file" id="SmallLogoInput" name="SmallLogo" :disabled="isSaving" @change="uploadLogo($event.target.name)" accept="image/*" class="input-file">
											</div>
										</div>
									</form>
								</div>
								<div class="row form-group col-12">
									<label class="mb-1 control-label">Default Timezone:</label>
									<el-select v-model="settings.Params.Timezone" style="width: 200px;" default-first-option filterable>
										<el-option v-for="type in Timezones"
												   :value="type.TZCode"
												   :key="type.TZCode"
												   :label="type.CommonName">
										</el-option>
									</el-select>
								</div>

								<div class="row form-group col-12">
									<label class="control-label help" style="line-height: 35px; margin-right: 10px;">Primary Color:</label>
									<el-color-picker  v-model="settings.Params.PrimaryColor"></el-color-picker>
								</div>
							</el-tab-pane>
							<el-tab-pane label="Security" name="security">
								<div class="row form-group col-12">
									<label class="mb-1 control-label help" for="passwordMinLength">Minimum Password Length:</label>
									<input name="passwordMinLength" id="passwordMinLength" class="form-control smallNumber" type="number"  v-model="settings.Params.passwordMinLength">
								</div>
								<div class="row form-group col-12">
									<label class="mb-1 control-label help" for="passwordRequireUpper">Require at Least 1 Upper Case Letter:</label>
									<div class="custom-control help">
										<el-radio v-model="settings.Params.passwordRequireUpper" value="y">Yes</el-radio>
										<el-radio v-model="settings.Params.passwordRequireUpper" value="n">No</el-radio>
									</div>
								</div>
								<div class="row form-group col-12">
									<label class="mb-1 control-label help" for="passwordRequireUpper">Require at Least 1 Number:</label>
									<div class="custom-control">
										<el-radio v-model="settings.Params.passwordRequireNumber" value="y">Yes</el-radio>
										<el-radio v-model="settings.Params.passwordRequireNumber" value="n">No</el-radio>
									</div>
								</div>
							</el-tab-pane>
						</el-tabs>
					</el-form>
				</div>
			</div>
		</div>
		<div class="row" >
            <div class="col-12 text-center">
                <button class="btn btn-success btn-icon" @click="saveSettings" style="margin-right: 10px;">
                    <i class="fas fa-check"></i> <span> Save Changes</span>
                </button>
                <button class="btn btn-icon btn-dark cancel"  @click="reset(true)">
                    <i class="fas fa-times"></i>  <span>Cancel</span>
                </button>
            </div>
        </div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import axios from 'axios';

	const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
	export default {
		data () {
			return {
				activeTab: 'display',
				currentStatus : 0,
				settings : {"Params" : {}},
				Timezones : [],
			}
		},
		name: 'Settings',
		props: {
			config: {
				type: Object,
				required: true,
				default: () => {}
			},
			height: {
				type: Number,
				required: true,
				default: 600
			},
		},
		computed: {
			...mapGetters({ currentUser: 'currentUser' }),
			isInitial() {
				return this.currentStatus === STATUS_INITIAL;
			},
			isSaving() {
				return this.currentStatus === STATUS_SAVING;
			},
			isSuccess() {
				return this.currentStatus === STATUS_SUCCESS;
			},
			isFailed() {
				return this.currentStatus === STATUS_FAILED;
			},
            defaultLogo () {
                return require('../images/default_avatar.png')
            },
            mainLogo() {
                let logo = 'backgroundImage: url(' + (this.settings.Params.MainLogo ? this.settings.Params.MainLogo : this.defaultLogo) + ')';
                return logo;
            },
            smallLogo() {
                let logo = 'backgroundImage: url(' + (this.settings.Params.SmallLogo ? this.settings.Params.SmallLogo : this.defaultLogo) + ')';
                return logo;
            },
		},
		methods: {
			reset(showMessage) {
				if (showMessage) {
					this.$root.$emit('refreshData');
				} else {
					// reset form to initial state
					this.currentStatus = STATUS_INITIAL;
					if (showMessage) {
						this.getSettingsData();
						this.$notify({
							title: 'Success',
							message: "Settings have been reset",
							type: 'success',
							duration: 1500,
							showClose: false
						});
	                 }
	            }
			},
			getInitialData () {
				var tables = ['Timezones','InvoiceSettings'];
				axios.post('/index/tableData', {'tables': tables },
				)
                .then(response => {
                    if (response.data.result == 'success') {
                        for (let value of tables) {
                            this[value] = response.data[value];
                        }
						this.getSettingsData();
                    } else {
                    }
                }).catch(response => {
                });
			},
			getSettingsData () {
				axios.post('/settings/get', {},
				)
                .then(response => {
                    if (response.data.result == 'success') {
						this.settings = response.data.settings;
                    } else {
                    }
                }).catch(response => {
                });
			},
			uploadLogo(fieldName) {
				if (this.currentStatus == STATUS_SAVING) {
                    return true;
                }
				// upload data to the server
				this.currentStatus = STATUS_SAVING;
				axios.post('/settings/uploadlogo', document.querySelector('#' + fieldName + 'Input').files,
					{ headers: { 'Content-Type': 'multipart/form-data'} }
					)
					.then(response => {
						if (response.data.result == 'success') {
							this.currentStatus = STATUS_SUCCESS;
							this.settings.Params[fieldName] = response.data.url;
						} else {
							this.currentStatus = STATUS_FAILED;
							this.displayPopup (response.data.message);
						}
						document.getElementById(fieldName + 'Input').value = "";
					}).catch(response => {
						this.currentStatus = STATUS_FAILED;
				});
			},
			saveSettings () {
				if (this.currentStatus == STATUS_SAVING) {
					return true;
				}
				this.currentStatus = STATUS_SAVING;

				axios.post('/settings/save', {'settings': this.settings}
				)
				.then(response => {
					if (response.data.result == 'success') {
						this.currentStatus = STATUS_INITIAL;
                        var configElement = document.getElementById( 'config-settings' );
                        configElement.innerHTML = JSON.stringify(this.settings);
						this.$notify({
							title: 'Success',
							message: "Settings have been saved",
							type: 'success',
							duration: 1500,
							showClose: false
						});
		                let self = this;
		                setTimeout(() => { self.$router.go(this.$router.currentRoute); }, 1000);
					} else {
						this.currentStatus = STATUS_FAILED;
						this.displayPopup (response.data.message);
					}
				}).catch(response => {
					this.currentStatus = STATUS_FAILED;
				});
			},
	        displayPopup (message) {
				this.$alert(message, 'Settings Error', {
					confirmButtonText: 'OK',
				});
	        }
		},
		mounted() {
			this.reset(false);
			this.getInitialData();
		},
	}
</script>


<style scoped>
	#mainLogo, #smallLogo {
		min-width: 50%;
		background: #FFFFFF left center no-repeat;
		background-size: contain;
		cursor: pointer;
	}
	#mainLogo {
		height: 150px;
	}
	#smallLogo {
		height: 50px;
	}
	#settings .logo .success_upload {
		border: 4px solid #28a745;
	}
	#settings .logo .failed_upload {
        border: 4px solid #dc3545;
    }
    #settings .form-horizontal {
        width: 100%;
    }
	.input-file {
		opacity: 0; /* invisible but it's there! */
		width: 100%;
		height: 100%;
		position: absolute;
		cursor: pointer;
		left:0;
	}
	.card {
		padding-top: 0px;
		padding-bottom: 0px;
	}
	.form-control:disabled.not-available {
		border : 0px;
		background: #fff;
		-webkit-appearance: none;
		margin: 0px 0px 0px -11px;
	}
	select::-ms-expand.form-control:disabled.not-available  {
        display: none;
    }
    .custom-control {
        width: 100%;
    }
    label.control-label.help, label.el-radio {
        width: auto;
    }
	.half {
		min-width: 250px;
		width: 50%;
		margin-right: 50%
	}
	label.control-label {
		width: 100%;
	}
</style>
